// Created on 2021-04-10
// Copyright (c) 2021 Vilten s.r.o. - All Rights Reserved
// Unauthorized copying of this file, via any medium is strictly prohibited
// Proprietary and confidential
// Written by Viliam Tencer <vilten@vilten.sk>, 2021-04-10
import { createWebHashHistory, createRouter } from 'vue-router'
import Home from '@/components/views/Home'
import Customers from '@/components/views/Customers'
import CustomerDetail from '@/components/views/CustomerDetail'
import Database from '@/components/views/Database'
import Login from '@/components/views/Login'
import Profile from '@/components/views/Profile'
import EnterPIN from '@/components/views/EnterPIN'
import Orders from '@/components/views/Orders'
import OrderDetail from '@/components/views/OrderDetail'

const routes = [
  {
    path: '/home',
    name: 'Home',
    component: Home,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/order-detail',
    name: 'OrderDetail',
    component: OrderDetail,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/database',
    name: 'Database',
    component: Database,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/customer-detail/:id',
    name: 'Customer Detail',
    component: CustomerDetail,
    props: true,
    meta: {
      roles: [
        'AUTH_ROLE_MEMBER'
      ]
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/enter-pin',
    name: 'EnterPIN',
    component: EnterPIN
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/home'
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes,
})

export default router